import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CountdownConfig, CountdownEvent } from 'ngx-countdown';

@Component({
  selector: 'app-duplicate-login-waiting',
  templateUrl: './duplicate-login-waiting.component.html',
  styleUrls: ['./duplicate-login-waiting.component.scss'],
})
export class DuplicateLoginWaitingComponent {
  config: CountdownConfig = { leftTime: 10 };

  constructor(public modalService: NgbModal) {}

  handleEvent(event: CountdownEvent): void {
    if (event.action === 'done') {
      this.modalService.dismissAll();
    }
  }
}
